import React, { useState, useCallback } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import GameBox from "../components/GameBox";
import GamePlayer from "../components/GamePlayer";
import { Helmet } from "react-helmet";
import GameFullScreen from "./GameFullScreen";
import { useNavigate } from "react-router-dom";
import AdCard from "../AdComponents/AdCard";
import { type } from "@testing-library/user-event/dist/type";

// Sample game data for scalability
const games = [
    {
        id: "tictactoe",
        title: "Tic Tac Toe",
        type: "game",
        description: "A classic two-player game where each player takes turns marking X or O. Get three in a row to win!",
        thumbnail: "https://img.poki-cdn.com/cdn-cgi/image/quality=78,width=314,height=314,fit=cover,f=auto/591a911d9b73482c052270a8fe4cfc95.png",
    },
    {
        id: "bombreward",
        title: "Bomb & Reward",
        type: "game",
        description: "A thrilling two-player game where each box hides either a reward or a bomb. Score points by collecting rewards — but hit a bomb and your turn ends!",
        thumbnail: "https://cdn.mobygames.com/63a3935c-ac04-11ed-b013-02420a00012e.webp"
    },
    {
        id: "snake",
        title: "Snake Game",
        type: "game",
        description: "Relive the nostalgia with this classic Snake game. Eat, grow, and avoid hitting the walls!",
        thumbnail: "https://i.pinimg.com/564x/18/24/5b/18245b766e5ae817bc527e74897d7181.jpg",
    },
    {
        id: "snake",
        title: "Snake Game",
        description: "Relive the nostalgia with this classic Snake game. Eat, grow, and avoid hitting the walls!",
        thumbnail: "https://i.pinimg.com/564x/18/24/5b/18245b766e5ae817bc527e74897d7181.jpg",
    },
    {
        id: "boxclicker",
        title: "Box Clicker",
        type: "game",
        description: "Test your reflexes! Click the box as fast as you can to boost your score and set a new high!",
        thumbnail: "https://img.itch.zone/aW1hZ2UvMjQwNTA1LzExNDU4OTQucG5n/original/Gf2MoB.png",
    },
    {
        id: "boxclicker",
        title: "Box Clicker",
        description: "Test your reflexes! Click the box as fast as you can to boost your score and set a new high!",
        thumbnail: "https://img.itch.zone/aW1hZ2UvMjQwNTA1LzExNDU4OTQucG5n/original/Gf2MoB.png",
    },
    {
        title: "Memory Match Game",
        description: "A 4x4 grid of cards face down. Players take turns flipping 2 cards. Matching pair grants a point and another turn. Non-matching pair switches turn. Game ends when all pairs matched; player with most points wins.",
        thumbnail: "https://store-images.s-microsoft.com/image/apps.54588.14090654178473619.aa2706f7-9244-4d37-b59f-3f87f7589476.6a5a6db1-70ba-4b57-a879-7f9264cd3a40?h=1280",
        id: "memorymatch",
        type: "game"
    },
    {
        "title": "Sudoku Game",
        "description": "A classic Sudoku puzzle game where players fill a 9x9 grid with numbers 1-9, ensuring each number appears only once per row, column, and 3x3 subgrid. Perfect for enhancing logical thinking and problem-solving skills.",
        "id": "sudokugame",
        "thumbnail": "https://img.freepik.com/free-vector/hand-drawn-flat-design-sudoku_23-2149281226.jpg?semt=ais_items_boosted&w=740",
        "type": "game"
    },
    {
        "title": "Word Rush Game",
        "description": "A fast-paced typing game where players take turns forming unique valid words starting with a given letter within a 10-second timer. Longer words earn bonus points. The player with the highest score after 20 words wins.",
        "thumbnail": "https://game-game.com/gamesimg/265420.jpg",
        "id": "wordrushgame",
        "type": "game"
    }
    // Add more games as needed
];

export default function Home() {
    const [activeGameId, setActiveGameId] = useState(null);

    const navigate = useNavigate();
    const openGame = useCallback(
        (id) => {
            setActiveGameId(id);
            navigate(`/game/${id}`);
        },
        [navigate]
    );
    return (
        <>
            <Helmet>
                <title>Fun Games - Play Online</title>
                <meta name="description" content="Enjoy a variety of fun games online. Play Tic Tac Toe, Snake and many more!" />
                <meta name="robots" content="index, follow" />
            </Helmet>
            <Box
                component="main"
                sx={{
                    p: 4,
                    bgcolor: "background.default",
                    minHeight: "100vh",
                }}
            >
                <Typography variant="h3" component="h1" gutterBottom>
                    Welcome to School Fun Zone!
                </Typography>
                <Typography variant="subtitle1" mb={4}>
                    A special collection of games curated just for our students — click any game and start playing!
                </Typography>
                <Grid container justifyContent="center" spacing={3}>
                    {games.map((game) => (
                        <Grid item key={`${game.id}0oio9`}>
                            {
                                game.type == "game" ? (<GameBox game={game} onClick={openGame} />)
                                    : (<AdCard />)
                            }
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    );
}